import React, { useEffect, useState } from 'react';

export type NumericEntry_inputExProps = {
  value: number | null;
  minValueLimit?: number;
  maxValueLimit?: number;
  onChange?: (value: number | null) => void;
  fixed?: number; //小数点桁数指定
  className?: string;
};

/**
 * 上下限値に応じた値を設定
 * @param val
 * @param minLimit
 * @param maxLimit
 * @returns
 */
const CheckValLimit = (val: number | null, minLimit?: number, maxLimit?: number): number | null => {
  console.debug([`CheckValLimit val = ${val} minLimit=${minLimit} maxLimit=${maxLimit}`]);
  var ret = val;
  if (ret !== null) {
    if (minLimit != null && ret < minLimit) {
      ret = minLimit;
    }
    if (maxLimit != null && ret > maxLimit) {
      ret = maxLimit;
    }
  }
  return ret;
};

/**
 * 数値入力 最大値 最小値 設定可能コンポーネント
 * @param props
 * @returns
 */
const NumericEntry_input_EmptyUse: React.FC<NumericEntry_inputExProps> = (props: NumericEntry_inputExProps) => {
  console.debug(['NumericEntry_input_EmptyUse - props', props]);
  const initVal = props.fixed != undefined ?
    (props.value == undefined || props.value == null ? '' : props.value.toFixed(props.fixed)) :
    (props.value == undefined || props.value == null ? '' : props.value.toString());
  const [val, setVal] = useState<string>('');
  //console.debug(['NumericEntry_input_EmptyUse - initVal', initVal, val]);
  useEffect(() => {
    console.debug(['NumericEntry_input_EmptyUse - useEffect', initVal, val]);
  }, [props.value]);

  useEffect(() => {
    setVal(initVal ?? '');
    console.debug(['-NumericEntry_input_EmptyUse - useEffect first', initVal, val]);
  }, []);

  return (
    <input
      type="text"
      className={'MuiInput-underline' + ' ' + props.className}
      value={val}
      style={{ textAlign: 'right' }}
      onChange={(e) => {
        const inputValue = e.target.value;
        //console.debug(['-NumericEntry_inputExCopy  input', inputValue]);

        if (props.onChange) {
          if (inputValue.trim() === '') {
            //props.onChange(null); // ブランクはnullとして扱う
            console.debug(['-NumericEntry_input_EmptyUse brank', inputValue]);
            setVal('');
          } else {
            const parsedValue = parseFloat(inputValue);
            if (!isNaN(parsedValue)) {
              console.debug(['-NumericEntry_input_EmptyUse not empty-', inputValue]);
              setVal(inputValue);
            }
            else {
              console.debug(['-NumericEntry_input_EmptyUse empty-', inputValue]);
              setVal('');
            }
          }
        }
      }}
      onBlur={(e) => {
        //入力値が空の場合
        if (val.trim() === '') {
          if (props.onChange) {
            props.onChange(null);
          }
        }
        else {
          //入力値が空でない場合
          const cv = CheckValLimit(val !== '' ? parseFloat(val) : null, props.minValueLimit, props.maxValueLimit);
          const ret = props.fixed != undefined ? (cv !== null ? cv.toFixed(props.fixed) : '') : (cv !== null ? cv.toString() : '');
          console.debug(`-NumericEntry_input_EmptyUse onBlur - props.fixed:${props.fixed}, setval:${ret}`);
          setVal(ret);

          if (props.onChange) {
            props.onChange(Number(ret));
          }
        }
      }}
      onFocus={(e) => e.target.select()}
    />
  );
};

export default NumericEntry_input_EmptyUse;
